// import React, { useState } from "react";
// import Swal from "sweetalert2";
// import api from "../../../api/axios";
// import * as XLSX from "xlsx";

// const EmployeeUpload = () => {
//   const [file, setFile] = useState(null);
//   const [uploading, setUploading] = useState(false);

//   const handleFile = (e) => {
//     setFile(e.target.files[0]);
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       Swal.fire("Warning", "Please select a file", "warning");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       setUploading(true);
//       const res = await api.post("hrms/employees/upload", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       Swal.fire("Success", "Roster uploaded successfully", "success");
//     } catch {
//       Swal.fire("Error", "Failed to upload file", "error");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const downloadSampleEmployeeExcel = () => {
//     const sampleData = [
//       {
//         first_name: "John",
//         last_name: "Doe",
//         email: "john.doe@example.com",
//         employee_code: "EMP001",
//         department: "Engineering",
//         designation: "Engineer",
//         outlet: "Main Building",
//         date_of_joining: "2025-01-01",
//         shift_start_time: "09:00",
//         shift_end_time: "18:00",
//       },
//     ];

//     const worksheet = XLSX.utils.json_to_sheet(sampleData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Sample Employees");

//     XLSX.writeFile(workbook, "sample_employee.xlsx");
//   };

//   return (
//     <div className="p-4">
//       <h5 className="fw-semibold">Upload Excel File</h5>

//       <div className="mt-4">
//         <input type="file" className="form-control" onChange={handleFile} />
//         <div>
//           <button
//             className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
//             onClick={handleUpload}
//             disabled={uploading}
//           >
//             {uploading ? "Uploading..." : "Upload"}
//           </button>
//           <button
//             className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
//             onClick={downloadSampleEmployeeExcel}
//           >
//             Download Sample Employee Excel
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EmployeeUpload;

import React, { useState } from "react";
import Swal from "sweetalert2";
import api from "../../../api/axios";
import * as XLSX from "xlsx";
import { Download, FileUp, Info } from "lucide-react";

const EmployeeUpload = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadedEmployees, setUploadedEmployees] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFile = (e) => {
    setFile(e.target.files[0]);
  };

  // Sample Excel download
  const downloadSampleEmployeeExcel = () => {
    const sampleData = [
      {
        first_name: "John",
        last_name: "Doe",
        email: "john@example.com",
        employee_code: "EMP001",
        department: "Engineering",
        designation: "Engineer",
        outlet: "Main Unit",
        date_of_joining: "2025-01-01",
        shift_start_time: "09:00",
        shift_end_time: "18:00",
      },
    ];

    const ws = XLSX.utils.json_to_sheet(sampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");

    XLSX.writeFile(wb, "sample_employee.xlsx");
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      Swal.fire("Warning", "Please select a file", "warning");
      return;
    }

    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await api.post("/hrms/employees/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const response = res.data.data;

      if (response.errors && response.errors.length > 0) {
        let html = "";

        response.errors.forEach((err) => {
          html += `
          <div style="text-align:left; margin-bottom:8px;">
            <strong>Row ${err.row}</strong> (${err.employee_code})<br/>
            ${Object.keys(err.errors)
              .map((k) => `• ${err.errors[k][0]}`)
              .join("<br/>")}
          </div>
        `;
        });

        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          html: html,
          width: 500,
        });

        return;
      }

      Swal.fire("Success", "File uploaded successfully!", "success");

      setUploadedEmployees(res.data.data || []);
    } catch (err) {
      Swal.fire("Error", "Upload failed", "error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="duty-roster-upload">
      <div className="duty-roster-upload-cont">
        <div class="d-flex flex-column">
          <h5 class="fs-4 fw-semibold m-0">Upload & Validate Employee Details</h5>
          <span class="text-muted fs-6">
            Select an Excel file to check for errors before processing.
          </span>
        </div>
        <div className="duty-roster-upload-inner-cont mt-3">
          <Info size={20} />
          <div class="d-flex flex-column">
            <h6 class="fs-5 fw-semibold m-0">File Format Instructions</h6>
            <span class="text-dark fs-6">
              Ensure your Excel file has a column named 'Emp. Code' for
              validation. You can download a sample file to see the required format.
            </span>
          </div>
        </div>

        {/* Choose File */}
        <div className="row row-gap-3 mt-4">
          <form onSubmit={handleUpload} className="row align-items-center g-3">
            <div className="col-lg-8 col-sm-12 col-12">
              <input
                type="file"
                accept=".xlsx, .xls"
                className="form-control"
                onChange={handleFile}
                disabled={uploading}
              />
            </div>

            <div className="col-lg-2 col-sm-12 col-12">
              <button
                type="submit"
                disabled={uploading || !file} // <--- FIXED
                className="btn duty-roster-upload-btn gap-1 w-100"
              >
                {uploading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Uploading...
                  </>
                ) : (
                  <>
                    <FileUp size={16} />
                    Upload & Process
                  </>
                )}
              </button>
            </div>

            <div className="col-lg-2 col-sm-12 col-12">
              <button
                type="button"
                className="btn duty-roster-sample-btn gap-2 w-100"
                onClick={downloadSampleEmployeeExcel}
              >
                <Download size={16} />
                Sample
              </button>
            </div>
          </form>
        </div>

        {/* Uploaded Employee List */}
        {uploadedEmployees.length > 0 && (
          <>
            <h5 className="mt-4 fw-semibold">Uploaded Employees</h5>

            <div className="table-responsive mt-3">
              <table className="table table-bordered">
                <thead>
                  <tr className="text-muted small">
                    <th>Name</th>
                    <th>Email</th>
                    <th>Employee Code</th>
                    <th>Department</th>
                    <th>Designation</th>
                    <th>Shift</th>
                  </tr>
                </thead>

                <tbody>
                  {uploadedEmployees.map((emp, index) => (
                    <tr key={index}>
                      <td>
                        {emp.first_name} {emp.last_name}
                      </td>
                      <td>{emp.email}</td>
                      <td>{emp.employee_code}</td>
                      <td>{emp.department}</td>
                      <td>{emp.designation}</td>
                      <td>
                        {emp.shift_start_time} - {emp.shift_end_time}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EmployeeUpload;
